// extracted by mini-css-extract-plugin
module.exports = {"content":"CommonCardA_content__k0E4L","lowcodeimg":"CommonCardA_lowcodeimg__YnQ_S"};